import ReactSelect, {
    createFilter,
    ActionMeta,
    GroupBase,
    GetOptionLabel,
    GetOptionValue,
    OptionsOrGroups,
    SingleValue,
    StylesConfig,
} from 'react-select';
import {Form} from 'react-bootstrap';
import {useIntl} from 'react-intl';

interface SelectProps<T> {
    label?: string;
    isDisabled?: boolean;
    isLoading?: boolean;
    isClearable?: boolean;
    isSearchable?: boolean;
    name?: string;
    onChange?: (newValue: SingleValue<T>, actionMeta: ActionMeta<T>) => void;
    value?: T;
    getOptionValue?: GetOptionValue<T>;
    getOptionLabel?: GetOptionLabel<T>;
    options?: OptionsOrGroups<T, GroupBase<T>>;
    placeholder?: string;
    touched?: boolean;
    error?: string;
    isMulti?: boolean;
}

const Select = <T,>({
    label,
    isDisabled,
    isLoading,
    isClearable,
    isSearchable,
    name,
    onChange,
    value,
    getOptionValue,
    getOptionLabel,
    options,
    placeholder,
    touched,
    error,
    isMulti,
}: SelectProps<T>): JSX.Element => {
    const intl = useIntl();

    const customStyles: StylesConfig<T> = {
        control: (styles) => ({
            ...styles,
            borderColor: '#f1416c',
            '&:hover': {
                borderColor: '#f1416c',
            },
        }),
    };

    return (
        <Form.Group>
            {label && <Form.Label className="fw-bold fs-3">{label}</Form.Label>}
            <ReactSelect<T>
                {...(touched && error && {styles: customStyles})}
                noOptionsMessage={() => intl.formatMessage({id: 'FIELD.NO.OPTIONS'})}
                classNamePrefix="select"
                isDisabled={isDisabled}
                isLoading={isLoading}
                isClearable={isClearable}
                isSearchable={isSearchable}
                name={name}
                onChange={onChange}
                value={value ?? null}
                getOptionValue={getOptionValue}
                getOptionLabel={getOptionLabel}
                options={options}
                placeholder={placeholder}
                filterOption={createFilter({stringify: (element) => element.label})}
                /*
                // @ts-ignore */
                isMulti={isMulti}
            />
            {touched && error && (
                <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                        <span role="alert">{error}</span>
                    </div>
                </div>
            )}
        </Form.Group>
    );
};

export default Select;
